import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SalesPortalActivityNotesDocument = gql`
  query SalesPortalActivityNotes(
    $restaurantUUID: uuid!
    $supplierUUID: uuid!
    $cursor: uuid
    $pageSize: Int
  ) {
    getCrmActivities(
      restaurant_id: $restaurantUUID
      supplier_id: $supplierUUID
      cursor: $cursor
      page_size: $pageSize
    ) {
      cursor
      activities {
        uuid
        created_at
        created_by_name
        note {
          content
        }
        check_in {
          interactions
        }
        reminder {
          uuid
          remind_at
        }
      }
    }
  }
`;
export function useSalesPortalActivityNotesQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalActivityNotesQuery,
    Types.SalesPortalActivityNotesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalActivityNotesQuery,
    Types.SalesPortalActivityNotesQueryVariables
  >(SalesPortalActivityNotesDocument, options);
}
export function useSalesPortalActivityNotesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalActivityNotesQuery,
    Types.SalesPortalActivityNotesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalActivityNotesQuery,
    Types.SalesPortalActivityNotesQueryVariables
  >(SalesPortalActivityNotesDocument, options);
}
export type SalesPortalActivityNotesQueryHookResult = ReturnType<
  typeof useSalesPortalActivityNotesQuery
>;
export type SalesPortalActivityNotesLazyQueryHookResult = ReturnType<
  typeof useSalesPortalActivityNotesLazyQuery
>;
export type SalesPortalActivityNotesQueryResult = Apollo.QueryResult<
  Types.SalesPortalActivityNotesQuery,
  Types.SalesPortalActivityNotesQueryVariables
>;

/**
 * Wrapped version of useGeneratedSalesPortalActivityNotesQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalActivityNotesQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalActivityNotesQuery,
    Types.SalesPortalActivityNotesQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalActivityNotesQuery,
    Types.SalesPortalActivityNotesQueryVariables
  >(SalesPortalActivityNotesDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalActivityNotesLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalActivityNotesLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalActivityNotesQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalActivityNotesQuery,
    Types.SalesPortalActivityNotesQueryVariables
  >(SalesPortalActivityNotesDocument, lazyOptions);
}
